export const searchObjectToParams = (search: Record<string, unknown>): URLSearchParams =>
  new URLSearchParams(
    Object.entries(search)
      .filter(([, v]) => v !== undefined && v !== null)
      // Object/array-valued params (e.g. the 720 embed's `slxapi`) must be JSON-serialized, not coerced
      // with String() — String({...}) yields '[object Object]', which round-trips back through the
      // router's JSON search parser as an invalid value and fails route validation. Strings/numbers/
      // booleans keep their existing textual form (String(2) === JSON.stringify(2) === '2').
      .map(([k, v]) => [k, typeof v === 'string' ? v : JSON.stringify(v)])
  );

type UpdateParamInUrlBase = {
  pathname: string | null;
  searchParams: URLSearchParams | null;
};
export const updateParamInUrl = (key: string, value: string | undefined | null, options: UpdateParamInUrlBase) => {
  if (!options.pathname) {
    return '';
  }

  if (!options.searchParams) {
    return options.pathname;
  }

  const updatedSeachParams = new URLSearchParams(options.searchParams.toString());
  if (value) {
    updatedSeachParams.set(key, value);
  } else {
    updatedSeachParams.delete(key);
  }

  return `${options.pathname}?${updatedSeachParams}`;
};

//TODO: remove this after removing pages
export const parseQueryParam = (param: string | string[] | undefined) => (Array.isArray(param) ? param[0] : param);
